<template>
    <div class="gift-modal">
        <div class="gift-modal__backdrop" @click="close"></div>
        <div class="gift-modal__content">
            <div class="gift-modal__head" v-if="$device.isMobile">
                <div @click="close" class="gift-modal__head-close">{{ $i18n.t("close") }}</div>
            </div>
            <div class="gift-modal__form">
                <div @click="close" v-if="$device.isDesktop" class="gift-modal__form-close">
                    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M15.5 17.2222L21.2778 23L22 22.2778L16.2222 16.5L22 10.7222L21.2778 10L15.5 15.7778L9.72222 10L9 10.7222L14.7778 16.5L9 22.2778L9.72222 23L15.5 17.2222Z"
                            fill="black" />
                    </svg>
                </div>

                <div class="text_24">подарочная карта post post scriptum</div>
                <div class="gift-modal__type-toggle">
                    <div
                        class="info__button text_15"
                        :class="{ 'info__button--current': isOtherTypeSending }"
                        @click="setTypeSending('other')">
                        другому человеку
                    </div>

                    <div
                        class="info__button text_15"
                        :class="{ 'info__button--current': isSelfTypeSending }"
                        @click="setTypeSending('self')">
                        себе
                    </div>
                </div>

                <template v-if="isOtherTypeSending">
                    <div
                        class="form-group other"
                        :class="{ 'small-column': !$device.isDesktop }"
                        v-for="(group, index) in typeOtherForm[0].groups"
                        :key="index">
                        <template v-for="(input, name, inputIndex) in group">
                            <Input
                                v-if="input.type !== 'select'"
                                :key="'input-' + inputIndex"
                                :inputClass="input.inputClass"
                                :isValid="input.required ? input.isValid : true"
                                :validationMessage="input.required ? input.validationMessage : ''"
                                :type="input.type"
                                :name="name"
                                :label="input.label"
                                :required="input.required"
                                :cleaveOptions="input.cleaveOptions"
                                :labelDescription="input.labelDescription"
                                v-model="input.value"
                                :suggestion="input.suggestion"
                                :suggestionType="name"
                                :mask="input.mask" />

                            <Select
                                v-else
                                :key="'select-' + inputIndex"
                                :label="input.label"
                                :name="name"
                                :options="input.options"
                                :hasScroll="true"
                                :emintOnInit="true"
                                @change="input.change" />
                        </template>
                    </div>
                </template>

                <template v-if="isSelfTypeSending">
                    <div
                        class="form-group self"
                        :class="{ 'small-column': !$device.isDesktop }"
                        v-for="(group, index) in typeSelfForm[0].groups"
                        :key="index">
                        <template v-for="(input, name, inputIndex) in group">
                            <Input
                                v-if="input.type !== 'select'"
                                :key="'input-' + inputIndex"
                                :inputClass="input.inputClass"
                                :isValid="input.required ? input.isValid : true"
                                :validationMessage="input.required ? input.validationMessage : ''"
                                :type="input.type"
                                :name="name"
                                :label="input.label"
                                :required="input.required"
                                :cleaveOptions="input.cleaveOptions"
                                :labelDescription="input.labelDescription"
                                v-model="input.value"
                                :suggestion="input.suggestion"
                                :suggestionType="name"
                                :mask="input.mask" />

                            <Select
                                v-else
                                :key="'select-' + inputIndex"
                                :label="input.label"
                                :name="name"
                                :options="input.options"
                                :hasScroll="true"
                                :emintOnInit="true"
                                @change="input.change" />
                        </template>
                    </div>
                </template>
            </div>
            <div class="gift-modal__preview">
                <UiImage v-if="imagePath" :path="imagePath" :desktop="{ width: 512 }" :lazy="false" />
                <ImagePlug v-else />

                <div class="gift-modal__payment">
                    <div class="gift-modal__payment-result">
                        <div class="text_19">итого к оплате</div>
                        <div class="text_19">{{ gift.price }} ₽</div>
                    </div>
                    <div class="buy-button buy-button--wide button button--wide button--dark" @click="payment">
                        оплатить картой
                    </div>
                    <div class="text_11">
                        <span class="color-text_2">нажимая на кнопку «оформить заказ», я принимаю</span>
                        <a href="/dokumenty/oferta/" class="" target="_blank">условия публичной оферты </a>
                        и
                        <a href="/dokumenty/soglashenie-ob-obrabotke-persnonalnyh-dannyh/" class="" target="_blank"
                            >политики конфиденциальности
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ImagePlug from "@/components/ImagePlug.vue";
import Input from "@/components/form/Input.vue";
import Select from "../form/Select.vue";
import UiImage from "./Image.vue";

export default {
    name: "GiftPaymentModal",
    components: { UiImage, Select, Input, ImagePlug },
    props: {
        gift: {
            type: Object,
            required: true,
        },
        errors: {
            type: Object,
        },
    },
    data() {
        return {
            currentTypeSending: "other",
            typeOtherForm: [
                {
                    groups: [
                        {
                            recipients_name: {
                                label: this.$i18n.t("recipients_name"),
                                required: true,
                                isValid: true,
                                validationMessage: "",
                                value: "",
                            },
                        },
                        {
                            recipients_phone: {
                                label: this.$i18n.t("recipients_phone"),
                                type: "tel2",
                                required: true,
                                isValid: true,
                                validationMessage: "",
                                value: "",
                            },
                        },
                        {
                            wish: {
                                label: this.$i18n.t("wish"),
                                type: "text",
                                isValid: true,
                                validationMessage: "",
                                value: null,
                            },
                        },
                        {
                            day_send: {
                                label: this.$i18n.t("day_send"),
                                type: "select",
                                isValid: true,
                                validationMessage: "",
                                options: {},
                                value: "",
                                change: this.changeDay,
                            },
                            time_send: {
                                label: this.$i18n.t("time_send"),
                                type: "select",
                                isValid: true,
                                validationMessage: "",
                                options: {},
                                value: "",
                                change: this.changeTime,
                            },
                        },
                        {
                            self_phone: {
                                label: this.$i18n.t("self_phone"),
                                type: "tel2",
                                isValid: true,
                                validationMessage: "",
                                value: "",
                                required: true,
                                isOnlyOtherTypeField: true,
                            },
                            self_name: {
                                label: this.$i18n.t("self_name"),
                                type: "text",
                                isValid: true,
                                validationMessage: "",
                                value: "",
                                required: true,
                            },
                        },
                        {
                            self_email: {
                                label: this.$i18n.t("self_email"),
                                required: true,
                                isValid: true,
                                validationMessage: "",
                                value: "",
                            },
                        },
                    ],
                },
            ],
            typeSelfForm: [
                {
                    groups: [
                        {
                            self_email: {
                                label: this.$i18n.t("self_email"),
                                required: true,
                                isValid: true,
                                validationMessage: "",
                                value: "",
                            },
                        },
                        {
                            self_phone: {
                                label: this.$i18n.t("self_phone"),
                                type: "tel2",
                                required: true,
                                isValid: true,
                                validationMessage: "",
                                value: "",
                            },
                        },
                        {
                            day_send: {
                                label: this.$i18n.t("day_send"),
                                type: "select",
                                isValid: true,
                                validationMessage: "",
                                options: {},
                                value: "",
                                change: this.changeDay,
                            },
                            time_send: {
                                label: this.$i18n.t("time_send"),
                                type: "select",
                                isValid: true,
                                validationMessage: "",
                                options: {},
                                value: "",
                                change: this.changeTime,
                            },
                        },
                    ],
                },
            ],
        };
    },
    computed: {
        isSelfTypeSending() {
            return this.currentTypeSending === "self";
        },
        isOtherTypeSending() {
            return this.currentTypeSending === "other";
        },
        imagePath() {
            return this.gift?.images[0]?.path;
        },
        otherSendingDay() {
            return this.typeOtherForm[0].groups[3].day_send.value;
        },
        selfSendingDay() {
            return this.typeSelfForm[0].groups[2].day_send.value;
        },
    },
    watch: {
        currentTypeSending(type) {
            const formGroups = {
                other: this.typeOtherForm[0].groups,
                self: this.typeSelfForm[0].groups,
            };

            let currentFormGroup = formGroups[type];

            for (let key in currentFormGroup) {
                for (let fieldsKey in currentFormGroup[key]) {
                    let formFiled = currentFormGroup[key][fieldsKey];
                    formFiled.isValid = true;
                    formFiled.validationMessage = "";
                }
            }
        },
        otherSendingDay() {
            this.typeOtherForm[0].groups[3].time_send.options = this.getHours();
        },
        selfSendingDay() {
            this.typeSelfForm[0].groups[2].time_send.options = this.getHours();
        },
        errors(values) {
            const formGroups = {
                other: this.typeOtherForm[0].groups,
                self: this.typeSelfForm[0].groups,
            };
            let currentFormGroup = formGroups[values.type];

            for (let key in currentFormGroup) {
                for (let fieldsKey in currentFormGroup[key]) {
                    let formFiled = currentFormGroup[key][fieldsKey];
                    if (values.data[fieldsKey]) {
                        formFiled.isValid = false;
                        formFiled.validationMessage = values.data[fieldsKey][0];
                    } else {
                        formFiled.isValid = true;
                        formFiled.validationMessage = "";
                    }
                }
            }
        },
    },
    methods: {
        setTypeSending(type) {
            this.currentTypeSending = type;
        },
        close() {
            this.$emit("close");
        },
        getYears() {
            // const months = [
            //     "Января",
            //     "Февраля",
            //     "Марта",
            //     "Апреля",
            //     "Майя",
            //     "Июня",
            //     "Июля",
            //     "Августа",
            //     "Сентября",
            //     "Октября",
            //     "Ноября",
            //     "Декабря",
            // ];

            const dateMap = {};
            const today = new Date();
            const year = today.getFullYear();
            const currentMonth = today.getMonth();
            const currentDate = today.getDate();

            const now = `${year}-${String(currentMonth + 1).padStart(2, "0")}-${String(currentDate).padStart(2, "0")}`;

            dateMap[now] = "Сейчас";

            return dateMap;

            //TODO когда будет доступна отложенная отправка в сrm
            // for (let month = currentMonth; month < 12; month++) {
            //     const daysInMonth = new Date(year, month + 1, 0).getDate();

            //     const startDay = month === currentMonth ? currentDate : 1;

            //     for (let day = startDay; day <= daysInMonth; day++) {
            //         const formattedDate = `${year}-${String(month + 1).padStart(2, "0")}-${String(day).padStart(
            //             2,
            //             "0"
            //         )}`;

            //         let dayMonthString;
            //         if (day === currentDate && month === currentMonth) {
            //             dayMonthString = "Сейчас";
            //         } else {
            //             dayMonthString = `${day} ${months[month]}`;
            //         }

            //         dateMap[formattedDate] = dayMonthString;
            //     }
            // }

            // return dateMap;
        },
        getHours() {
            const hoursList = {};

            // Получаем текущую дату
            const today = new Date();
            // const pickedDate = new Date(this.isSelfTypeSending ? this.selfSendingDay : this.otherSendingDay);
            // const isNow = today.getDay() === pickedDate.getDay();
            // let startHour = 0;

            let now = `${today.getHours()}:00`;
            hoursList[now] = "Сейчас";
            return hoursList;
            //TODO когда будет доступна отложенная отправка в сrm

            // if (isNow) {
            //     startHour = today.getHours();
            // }

            // for (let hour = startHour; hour < 24; hour++) {
            //     const formattedHour = hour.toString().padStart(2, "0");
            //     const formattedMinute = "00";

            //     if (isNow && startHour === hour) {
            //         hoursList[`${formattedHour}:${formattedMinute}`] = "Сейчас";
            //     } else {
            //         hoursList[`${formattedHour}:${formattedMinute}`] = `${formattedHour}:${formattedMinute}`;
            //     }
            // }

            // return hoursList;
        },
        payment() {
            if (this.currentTypeSending === "other") {
                this.$emit("payment", {
                    type: this.currentTypeSending,
                    sku_id: this.gift.id,
                    recipients_name: this.typeOtherForm[0].groups[0].recipients_name.value,
                    recipients_phone: this.typeOtherForm[0].groups[1].recipients_phone.value,
                    wish: this.typeOtherForm[0].groups[2].wish.value,
                    day_send: this.typeOtherForm[0].groups[3].day_send.value,
                    time_send: this.typeOtherForm[0].groups[3].time_send.value,
                    self_name: this.typeOtherForm[0].groups[4].self_name.value,
                    self_phone: this.typeOtherForm[0].groups[4].self_phone.value,
                    self_email: this.typeOtherForm[0].groups[5].self_email.value,
                });
            }

            if (this.currentTypeSending === "self") {
                this.$emit("payment", {
                    type: this.currentTypeSending,
                    sku_id: this.gift.id,
                    self_email: this.typeSelfForm[0].groups[0].self_email.value,
                    self_phone: this.typeSelfForm[0].groups[1].self_phone.value,
                    day_send: this.typeSelfForm[0].groups[2].day_send.value,
                    time_send: this.typeSelfForm[0].groups[2].time_send.value,
                });
            }
        },
        changeDay(data) {
            if (this.currentTypeSending === "other") {
                this.typeOtherForm[0].groups[3].day_send.value = data;
            }
            if (this.currentTypeSending === "self") {
                this.typeSelfForm[0].groups[2].day_send.value = data;
            }
        },
        changeTime(time) {
            if (this.currentTypeSending === "other") {
                this.typeOtherForm[0].groups[3].time_send.value = time;
            }
            if (this.currentTypeSending === "self") {
                this.typeSelfForm[0].groups[2].time_send.value = time;
            }
        },
    },
    beforeMount() {
        this.typeOtherForm[0].groups[3].day_send.options = this.getYears();
        this.typeSelfForm[0].groups[2].day_send.options = this.getYears();
        this.typeOtherForm[0].groups[3].time_send.options = this.getHours();
        this.typeSelfForm[0].groups[2].time_send.options = this.getHours();
    },
};
</script>

<style scoped lang="less">
.gift {
    &-modal {
        &__backdrop {
            position: fixed;
            inset: 0;
            background: #e4e4e480;
        }

        &__content {
            display: flex;
            position: fixed;
            z-index: 1000;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            min-width: 750px;

            @media @sm {
                top: 0;
                left: 0;
                min-width: unset;
                width: 100%;
                transform: unset;
                flex-direction: column;
                height: 100%;
                overflow: auto;
            }
        }

        &__form {
            width: 50%;
            padding: 32px;
            background: white;

            @media @sm {
                width: 100%;
            }

            .other.form-group:nth-child(6),
            .other.form-group:nth-child(8),
            .self.form-group:last-child {
                margin-top: 40px;
            }

            @media @sm {
                .other.form-group:nth-child(8) {
                    margin-top: unset;
                }

                .other.form-group:nth-child(6),
                .other.form-group:nth-child(7),
                .self.form-group:last-child {
                    margin-top: 40px;
                }
            }

            &-close {
                position: absolute;
                right: 15px;
                top: 15px;
                z-index: 10;
                cursor: pointer;
            }
        }

        &__head {
            position: absolute;
            width: 100%;
            border-bottom: 1px solid @border2;
            padding: 10px 20px 10px 10px;
            display: flex;
            flex-direction: row-reverse;

            &-close {
                display: inline-block;
                border-bottom: 1px solid black;
            }
        }

        &__type-toggle {
            margin-top: 24px;
            display: flex;
            gap: 16px;
        }

        .info__button {
            min-width: 32px;
            padding: 0 5px;
            height: 44px;
            border: 1px solid @border2;
            display: flex;
            align-items: center;
            justify-content: center;
            text-align: center;
            transition: border-color 0.3s ease 0s;
            cursor: pointer;
            -webkit-user-select: none;
            -moz-user-select: none;
            -ms-user-select: none;
            width: 100%;

            &--current {
                border-color: #000;
            }
        }

        &__preview {
            width: 50%;
            background: #f4f4f4;
            display: flex;
            flex-direction: column;
            justify-content: space-between;

            @media @sm {
                width: 100%;
            }

            .image-plug {
                width: 100%;
                display: flex;
                font-size: 4em;
                justify-content: center;
                align-items: center;
                height: 100%;
                min-height: unset;
            }
        }

        &__payment {
            background: #f9f9f9;
            padding: 32px;

            &-result {
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-bottom: 24px;
            }

            .buy-button {
                margin-bottom: 16px;
                height: 48px;
            }
        }
    }
}
</style>
